module.exports = __webpack_public_path__ + "static/media/earnings.c40170e1.svg";